<template>
    <div>

        <tooltip
            content="Auto-payouts can only be enabled if at least one payout automation feature (PayPal, Wise, or Intermediary Payouts) is active."
            v-if="!config.can_be_enabled">
            <toggle
                title="Enable auto-payouts without requests"
                v-model="enabled"
                :disabled="!config.can_be_enabled"
            >
                <template #description>
                    If enabled, all earned commissions will be paid out automatically using your schedule.
                </template>
            </toggle>
        </tooltip>

        <toggle
            v-else
            title="Enable auto-payouts without requests"
            name="automated_partner_payouts_creation"
            v-model="enabled"
            :disabled="!config.can_be_enabled"
        >
            <template #description>
                If enabled, all earned commissions will be paid out automatically using your schedule.
            </template>
        </toggle>

        <div class="mt-2 ml-8 pl-8" v-if="enabled">
            <ul>
                <li v-if="(props.config.paypal.enabled || props.config.bank.enabled) && automationUrl">
                    <btn :href="automationUrl" type="secondary" size="small">Manage</btn>
                </li>
                <li v-if="config.intermediary.enabled && intermediaryURL">
                    <btn :href="intermediaryURL" type="secondary" size="small">Manage</btn>
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup>

import {ref} from "vue";

const props = defineProps({
    program: {
        type: [Number, String],
        required: true,
    },
    config: {
        type: Object,
        required: true,
        can_be_enabled: false,
        default: {
            enabled: false,
            paypal: {
                enabled: false
            },
            bank: {
                enabled: false
            },
            intermediary: {
                enabled: false
            },
        }
    },
    automationUrl: {
        type: String,
        default: null
    },
    intermediaryURL: {
        type: String,
        default: null
    }
});

const config = ref(props.config);
const enabled = ref(config.value.enabled);

</script>
